const seoTexts = {
  'plurals': {
    'Oficina': 'Oficinas',
    'Residencial': 'Residencias',
    'Locales': 'Locales',
    'Industrias': 'Industrias',
    'Emprendimientos': 'Emprendimientos',
    'Terrenos': 'Terrenos',
    'Hoteles': 'Hoteles',
    'Campos': 'Campos',
    'Tasaciones': 'Tasaciones',
    'Sucursal Recoleta': 'Residencias',
    'Sucursal Palermo': 'Residencias',
    'Sucursal San Isidro': 'Residencias',
    'Sucursal Nordelta': 'Residencias',
    'Sucursal Puertos': 'Residencias',
    'Viviendas': 'Residencias'
  }
}

export default seoTexts



// WEBPACK FOOTER //
// ./src/constants/seoTexts.js